export default "__VITE_ASSET__BXps7o2$__"